import { get, getNonAuth, handleResponse } from "./base.service";
import { CONTROLLER, ACTION } from "../utilities/api.constants";

export const setAydinlatmaMetni = () => {
  return get(CONTROLLER.COMMON + ACTION.SET_AYDINLATMA_METNI).then(
    handleResponse
  );
};

export const getAydinlatmaMetni = () => {
  return get(CONTROLLER.COMMON + ACTION.GET_AYDINLATMA_METNI).then(
    handleResponse
  );
};

export const getCities = async () => {
  const result = await getNonAuth(CONTROLLER.COMMON + ACTION.GET_CITIES);
  return result.data.data;
};

export const getTowns = async (cityId) => {
  const result = await getNonAuth(
    CONTROLLER.COMMON + ACTION.GET_TOWNS + cityId
  );
  return result.data.data;
};

export const getKvkkMetni = async () => {
  return get(CONTROLLER.COMMON + ACTION.GET_KVKK_METNI).then(
    handleResponse
  );
};

export const getReferansGecerlilikKurallari = async () => {
  return get(CONTROLLER.COMMON + ACTION.GET_REFERANS_GECERLILIK_KURALLARI).then(
    handleResponse
  );
};

export const getSSSService = async () => {
  return get(CONTROLLER.COMMON + ACTION.GET_SSS).then(
    handleResponse
  );
};

export const getIp = async () => {
  return get(CONTROLLER.COMMON + ACTION.GET_IP).then(
    handleResponse
  );
};

export const getKvkkService = () => {
  return get(CONTROLLER.COMMON + ACTION.GET_KVKK).then(
    handleResponse
  );
};